import { useCompany } from '../../hooks/useCompany';
import { useCompanyPermissions } from '../../hooks/useCompanyPermissions';
import AlignLicenses from './AlignLicenses.component';
import GenerateLicenses from './GenerateLicenses.component';

const SupportLicensesHeader = () => {
  const { companyId } = useCompany();
  const { canCreateLicenses } = useCompanyPermissions(companyId);

  if (!canCreateLicenses) return null;

  return (
    <div className='flex gap-2'>
      <GenerateLicenses />
      <AlignLicenses />
    </div>
  );
};

export default SupportLicensesHeader;
